import {
  VISIBILITY,
  //checkIfSelectionValid,
} from '@learningblocks/protocol-constants/lib/Utilities';
const NEXT_COMPONENT = 'nextComponent';
const FINAL_POINT = 'finalPoint';

// check if selected Question option correct adn update accordingly
export function submitOEQAnswer(state, payload) {
  return {
    ...state,
    currentSection: updateSubmissionInCurrentSection(
      state.currentSection,
      payload
    ),
  };
}

function updateSubmissionInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: updateSubmissionInComponents(
      currentSection.components,
      payload
    ),
  };
}

function updateSubmissionInComponents(components, payload) {
  const {newcomponents} = components.reduce(
    (acc, component) => {
      // updating submitted OEQ component
      if (component.id === payload.componentID) {
        component = updateFeedbackComponent(component);
        if (component.hasOwnProperty(NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating finalPoint to display rest of contents in section
      if (component.hasOwnProperty(FINAL_POINT) && component.complete) {
        component = {...component, finalPoint: false};
      }

      if (
        acc.forward &&
        acc.forward.complete &&
        acc.forward.nextComponent === component.id
      ) {
        // updating forward component and setting its visibility
        component = {...component, visibility: VISIBILITY.VISIBLE};
        acc.forward = null;
      }

      acc.newcomponents = [...acc.newcomponents, component];
      return acc;
    },
    {
      forward: null,
      newcomponents: [],
    }
  );
  return newcomponents;
}

function updateFeedbackComponent(component) {
  if (component.responseArea !== null) {

    component.savedResponse = component.responseArea;
    //component.complete = true;

    if (component.totalAttempts !== -10) {
      component.totalAttempts -= 1;
    }
  }
  return component;
}
